module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    on: {
      "click": _vm.displayVersion
    }
  }, [(_vm.justword) ? _c('span', [_vm._v("Version")]) : _vm._e(), _vm._v(" "), (!_vm.justword) ? _c('span', {
    staticClass: "label label-primary",
    staticStyle: {
      "font-size": "1.3em",
      "font-weight": "normal"
    }
  }, [_vm._v("\n     Version: " + _vm._s(this.$hydrowareCommonJS.Version) + "\n  ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f40a4092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VersionSystem/VersionSystem.vue
// module id = 855
// module chunks = 1